import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
	HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AuthTokensService } from '../auth-tokens.service';
import { catchError, tap } from 'rxjs/operators';
import { SystemNotificationsServiceDataProvider } from '@services/system-notifications/system-notifications.service';
import { AccountServiceWebProvider } from '@web-services/user/account.service';
import { AppConstants } from '@models/appConstants';

@Injectable()
export class SystemNotificationInterceptor implements HttpInterceptor {
	lastSystemNotificationId: string;
	clonedReq;
	systemNotificationId: string;
	constructor(
		private authTokensService: AuthTokensService,
		private systemNotificationsService: SystemNotificationsServiceDataProvider,
		private accountService: AccountServiceWebProvider
	) {}
	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		this.clonedReq = req;
		const windowVariable = AppConstants.WEB_BUILD_VERSION;
		this.clonedReq = req.clone({
			headers: req.headers.set('WebBuildVersion', windowVariable)
		});

		return next.handle(this.clonedReq).pipe(
			tap((resp: HttpResponse<any>): void =>
				this.checkLastSystemNotificationId(resp)
			),
			catchError((err: HttpErrorResponse): Observable<HttpEvent<any>> =>
				Observable.throw(err)
			)
		);
	}

	private checkLastSystemNotificationId(
		req: HttpResponse<void> | HttpErrorResponse
	): void {
		const { headers } = req;
		if (headers) {
			if (headers.has('last-system-notification-id')) {
				const currentSystemNotificationId = headers.get(
					'last-system-notification-id'
				);
				this.lastSystemNotificationId = localStorage.getItem(
					'lastSystemNotificationId'
				);
				if (
					this.authTokensService.getAuthToken() &&
					this.accountService.isAdmin() === false
				) {
					if (currentSystemNotificationId !== this.lastSystemNotificationId) {
						this.systemNotificationsService
							.fetchSystemNotificationsData()
							.subscribe(data => data);
						localStorage.setItem(
							'lastSystemNotificationId',
							currentSystemNotificationId || ''
						);
					}
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/interceptors/systemNotification.interceptor.ts